import axios from 'axios';

export const fetch = async (url: any, type: any, payload: any, token: any) => {
  let resp = {};
  if (type.toLowerCase() === 'post') {
    try {
      resp = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`
        }
      });
      return resp;
    } catch (e: any) {
      return e.response;
    }
  }

  if (type.toLowerCase() === 'get') {
    try {
      resp = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`
        }
      });

      return resp;
    } catch (e: any) {
      return e.response;
    }
  }
};
